export const error = state => state.error
export const isLoading = state => state.isLoading
export const retrieved = state => state.retrieved
export const updated = state => state.updated
export const violations = state => state.violations
export const languages = state => state.languages
export const translation = state => state.translation
export const translationError = state => state.translationError
export const translationLoading = state => state.translationLoading
export const languagesLoading = state => state.languagesLoading
